import {FormControl, Stack, Textarea, Text} from '@primer/react'
import {PlaygroundInput} from './PlaygroundInput'
import {useCallback, useRef} from 'react'
import {usePlaygroundManager, type ModelState} from '../../../utils/playground-manager'

export default function ModelParameters({model, position}: {model: ModelState; position: number}) {
  const {modelInputSchema, systemPrompt, parameters} = model
  const manager = usePlaygroundManager()
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  const handleInputChange = (key: string, value: string | number | boolean | string[]) => {
    manager.handleRequestParameterChange(position, model, key, value)
    manager.setParametersHasChanges(position, true)
  }

  const handleSystemPromptChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      manager.setSystemPrompt(position, event.target.value)
      manager.setParametersHasChanges(position, true)
    },
    [manager, position],
  )
  return (
    <Stack gap="normal" className="p-0 p-md-3">
      {modelInputSchema?.parameters?.length === 0 && !modelInputSchema?.capabilities?.systemPrompt && (
        <div className="p-3 d-flex flex-column flex-items-center">
          <Text sx={{fontWeight: 'bold'}}>No parameters available</Text>
          <p>Currently, this model does not support any parameters for customization.</p>
        </div>
      )}
      {modelInputSchema?.capabilities?.systemPrompt && (
        <FormControl>
          <FormControl.Label>System prompt</FormControl.Label>
          <FormControl.Caption>Set the context for the model response.</FormControl.Caption>
          <Textarea
            ref={textAreaRef}
            value={systemPrompt}
            block={true}
            resize="vertical"
            rows={1}
            onChange={handleSystemPromptChange}
            name="systemPrompt"
            style={{height: 120}}
          />
        </FormControl>
      )}
      {/* For each of a model’s inputs, display form components */}
      {(modelInputSchema?.parameters || []).map(parameter => {
        return (
          <PlaygroundInput
            key={parameter.key}
            value={parameters[parameter.key] ?? ''}
            parameter={parameter}
            onChange={handleInputChange}
          />
        )
      })}
    </Stack>
  )
}

try{ ModelParameters.displayName ||= 'ModelParameters' } catch {}